'use client'

import { cn } from '@/lib/utils'
import { Base } from '@/ui/components'
import React, { useImperativeHandle, useRef } from 'react'
import { BaseProps } from './type'

interface Props extends BaseProps {
  children?: React.ReactNode
  ref?: React.Ref<HTMLElement>
  size?: 'md' | 'sm-fixed' | 'md-fixed'
}

const Container = ({
  children,
  className,
  styled,
  size,
  ref,
  ...props
}: Props) => {
  const comp = useRef<any>(null)
  useImperativeHandle(ref, () => comp.current as HTMLElement)

  return (
    <Base
      ref={comp}
      className={cn(
        'gap-container-gutter px-padding-md mx-auto w-full',
        className,
        !size && '2xl:max-w-[120rem]',
        size === 'md' && '2xl:w-[80%]',
        size === 'sm-fixed' && 'mx-auto max-w-[45rem]',
        size === 'md-fixed' && 'mx-auto max-w-[59.5rem]'
      )}
      styled={styled}
      {...props}
    >
      {children}
    </Base>
  )
}

Container.displayName = 'Container'

export default Container
